module.exports = __webpack_public_path__ + "img/image.069d914e.png";